
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface ImageFileSelectorProps {
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedFile: File | null;
  isUploading: boolean;
}

const ImageFileSelector: React.FC<ImageFileSelectorProps> = ({ 
  handleFileChange, 
  selectedFile, 
  isUploading 
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="image-upload" className="text-foreground font-medium">Select Image</Label>
      <div className="flex items-center gap-3">
        <Input
          id="image-upload"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          disabled={isUploading}
          className="bg-muted/30 border-2 border-border file:bg-primary file:text-primary-foreground file:border-0 file:font-medium file:px-3 file:py-2 file:mr-2 hover:file:bg-primary/90 transition-colors"
        />
      </div>
      {selectedFile && (
        <p className="text-sm text-muted-foreground mt-1">
          Selected: {selectedFile.name} ({Math.round(selectedFile.size / 1024)} KB)
        </p>
      )}
    </div>
  );
};

export default ImageFileSelector;
